module.exports = __webpack_public_path__ + "static/img/Logo-011.6cdc106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo-011.png
// module id = 3R9q
// module chunks = 1